import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70')
];

export const server_loads = [0,2,4];

export const dictionary = {
		"/": [~5],
		"/@[handle]": [~6,[2]],
		"/@[handle]/account": [~7,[2]],
		"/@[handle]/billing": [~8,[2]],
		"/@[handle]/gear": [~9,[2]],
		"/@[handle]/packs": [~10,[2,3]],
		"/@[handle]/packs/[id]": [~11,[2,3]],
		"/@[handle]/profile": [~12,[2]],
		"/@[handle]/shares": [~13,[2]],
		"/@[handle]/trips": [14,[2]],
		"/@[handle]/trips/[id]": [15,[2]],
		"/about": [16],
		"/account": [~17],
		"/auth-action": [~18],
		"/billing": [~19],
		"/changelog": [~20],
		"/dev": [21,[4]],
		"/dev/components": [22,[4]],
		"/dev/components/button": [23,[4]],
		"/dev/components/card": [24,[4]],
		"/dev/components/collapsible-panel": [25,[4]],
		"/dev/components/dialog": [26,[4]],
		"/dev/components/floating-action-button": [27,[4]],
		"/dev/components/icon-button": [28,[4]],
		"/dev/components/indicators": [29,[4]],
		"/dev/components/inline-confirm-button": [30,[4]],
		"/dev/components/inline-edit": [31,[4]],
		"/dev/components/inline-status": [32,[4]],
		"/dev/components/markdown-block": [33,[4]],
		"/dev/components/overlay-button": [34,[4]],
		"/dev/components/page-stats-bar": [35,[4]],
		"/dev/components/plan-gate": [36,[4]],
		"/dev/components/popover": [37,[4]],
		"/dev/components/search-box": [38,[4]],
		"/dev/components/select": [39,[4]],
		"/dev/components/settings": [40,[4]],
		"/dev/components/sticky-page-header": [41,[4]],
		"/dev/components/switch": [42,[4]],
		"/dev/components/toggle-group": [43,[4]],
		"/dev/components/tooltip": [44,[4]],
		"/dev/design": [45,[4]],
		"/dev/embeds": [46,[4]],
		"/dev/errors": [~47,[4]],
		"/dev/flags": [~48,[4]],
		"/dev/grid": [49,[4]],
		"/dev/icons": [50,[4]],
		"/dev/images": [51,[4]],
		"/dev/locale": [52,[4]],
		"/dev/tools": [53,[4]],
		"/dev/unused": [~54,[4]],
		"/e/[shareId]": [~55],
		"/features": [56],
		"/forgot-password": [~57],
		"/help": [58],
		"/onboarding": [~59],
		"/pricing": [~60],
		"/privacy": [61],
		"/profile": [~62],
		"/register": [~63],
		"/reset-password": [~64],
		"/sign-in": [~66],
		"/sign-out": [~67],
		"/s/[shareId]": [~65],
		"/terms": [68],
		"/verify-email": [~69],
		"/verify-email/apply": [~70]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';